import React, { createContext, useState, useContext } from 'react';

// Initialize progress as an empty object since the static file is gone
const initialProgress = {};

const TestContext = createContext();

export const useTest = () => useContext(TestContext);

export const TestProvider = ({ children }) => {
  const [testResult, setTestResult] = useState(null);
  const [userProgress, setUserProgress] = useState(initialProgress);

  const updateTopicStatus = (topicId, status) => {
    setUserProgress(prev => ({
      ...prev,
      [topicId]: status
    }));
  };

  const value = {
    testResult,
    setTestResult,
    userProgress,
    updateTopicStatus,
  };

  return <TestContext.Provider value={value}>{children}</TestContext.Provider>;
};
